import styled from "styled-components";
import { ReactComponent as DhlLogo } from "./dhl-logo.svg";

const StyledLogo = styled(DhlLogo)`
  height: 24px;
  width: 144px;
`;

function Logo() {
  return <StyledLogo />;
}

export default Logo;
